import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Trans} from '@lingui/macro'
import {Button} from 'components/UI/Button/Button'
import {logoutSagaAC} from 'model/system/systemActionCreators'
import {IdProductsState} from 'model/dashboardProducts/dProductsReducer'
import {getStoresListSlim} from 'model/dashboardStores/dStoresAPI'
import {InputCheckList, typeInputCheckboxItem} from 'components/UI/InputCheckboxList/InputCheckList'
import {dProductsBulkOffSaleSagaAC} from 'model/dashboardProducts/dProductsActionCreators'


// Type
export type typePopupBulkOffSale = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}



// Component
export const PopupBulkOffSale: React.FC<typePopupBulkOffSale> = ({variant, setOpenPopup}) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: {dProducts: IdProductsState}) => state.dProducts.filters)
    const pagination = useSelector((state: {dProducts: IdProductsState}) => state.dProducts.pagination)
    const dataList = useSelector((state: {dProducts: IdProductsState}) => state.dProducts.data)

    useEffect(() => {
        const setData = async () => {

                const responseStores = await getStoresListSlim()
                if(responseStores.status === 200) {
                    const objectList: typeInputCheckboxItem[] = responseStores.data.map((item: typeInputCheckboxItem) => ({
                        id: item.id,
                        name: item.id,
                        value: item.id,
                        label: item.name,
                        checked: false,
                    }))
                    const newSoreList = [...selectStoreList, ...objectList]
                    setSelectStoreList(newSoreList)
                } else if (responseStores.status === 401) {
                    dispatch(logoutSagaAC())
                }

        }
        setData()
        // eslint-disable-next-line
    }, [])

    const [selectStoreList, setSelectStoreList] = useState<typeInputCheckboxItem[]>([])

    const [disableTrue, setDisableTrue] = useState(true)

    useEffect(() => {
        if (selectStoreList.filter(item => item.checked === true).length) {
            setDisableTrue(false)
        } else {
            setDisableTrue(true)
        }
    }, [selectStoreList])

    const onOffSaleHandler = (e: React.FormEvent) => {
        e.preventDefault()
        const productIds = dataList
            .filter(item => item.checked)
            .map(item => item.id)
        const storeIds = selectStoreList
            .filter(item => item.checked === true)
            .map(item => item.id)
        dispatch(dProductsBulkOffSaleSagaAC( productIds, storeIds, filters, {page: pagination.pageNumber, size: pagination.itemsPerPage!}))
        setOpenPopup(false)
    }

    return(
        <form onSubmit={(e) => onOffSaleHandler(e)}>

            <div>
                <InputCheckList fieldsetClassName={`grid ${selectStoreList.length === 1 ? 'grid-cols-1' : selectStoreList.length === 2 ? 'grid-cols-2' : selectStoreList.length === 3 ? 'grid-cols-3' : 'grid-cols-4' } gap-x-6`} listLabel={<Trans>Store list</Trans>} dataList={selectStoreList} setDataList={setSelectStoreList}/>
            </div>

            <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <Button type="submit" disabled={disableTrue} variant={variant} label={<Trans>Off sale</Trans>}/>
                <Button type="button" secondary={true} label={<Trans>Cancel</Trans>} onClick={() => setOpenPopup(false)}/>
            </div>

        </form>
    )
}
